<template>
  <div class="root">
    <div v-if="items.length > 0">
      <div class="nav-rux-list" v-for="(_rux, index) in items" :key="index">
        <!-- Vue link that sends the user to the details page -->
        <router-link
          :to="{ name: 'Details', params: { serialNumber: _rux.serialNumber } }"
          :data-testid='"link-" + index'
        >
          <NavigationRuxListItem
            :value="_rux.value"
            :onClick="handleClick"
            :showImage="showImage"
          />
        </router-link>
      </div>
    </div>
    <div class="no-rux-found" v-else>No RUX found</div>
    <div v-if="showAll" class="item" @click="handleClick">
      <router-link to="/list"><div class="see-all">See All</div></router-link>
    </div>
  </div>
</template>
<script>
import NavigationRuxListItem from './NavigationRuxListItem'
export default {
  name: 'NavigationRuxList',
  // This prop is an event that is passed thru from the navlist.
  // It is currently used to hide this list after the user navigate between RUX'
  props: ['handleClick', 'items', 'showAll', 'showImage'],
  components: { NavigationRuxListItem },
  computed: {
    rux: function () {
      return this.$store.state.rux.ruxList
    },
  },
}
</script>
<style lang='scss' scoped>
.root {
  display: block;
  background-color: rgb(247, 247, 247);
  z-index: 20;

  a {
    color: white;
    text-decoration: none;
    text-align: left;
    width:100%;
  }
  .item{
    padding: 8px;
    text-transform: uppercase;
    .see-all{
      text-align:center;
    }
  }
  .nav-rux-list {
    color: white;
    background-color: black;
    border-bottom: 1px solid white;
  }
  .no-rux-found {
    text-align: left;
    color: white;
    background-color: black;
    border: 1px solid white;
    text-transform: uppercase;
    padding: 8px 20px;
  }
}
</style>
